<template>
  <the-header></the-header>
  <router-view v-slot="slotProps">
    <transition name="route" mode="out-in">
      <component :is="slotProps.Component"></component>
    </transition>
  </router-view>

  <the-footer></the-footer>
</template>

<script>
import TheHeader from './pages/allGazi/TheHeader.vue';
import TheFooter from './pages/allGazi/TheFooter.vue';

export default {
  components: {
    TheHeader,
    TheFooter,
  },
  computed: {},
  // created() {
  //   let theme = localStorage.getItem('theme');
  //   console.log(theme);

  //   if (theme) {
  //     let themeElement = document.getElementById('theme-link');
  //     if (themeElement) themeElement.setAttribute('href', theme);
  //   }
  // },
  watch: {},
};
</script>
